import * as yup from "yup";

import "yup-phone";
import * as Yup from "yup";
// require("yup-phone");

// validate any phone number (defaults to India for country)
const phoneSchema = yup.string().phone().required();

// const phoneRegExp = /^[2-9]{2}[0-9]{8}/;

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;


// Define password requirements
const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
// Minimum 8 characters, at least one uppercase letter, one lowercase letter, and one number

export const basicSchema = Yup.object().shape({
  signupFirstName: Yup.string()
      .min(2, "First name must be at least 2 characters")
      .max(50, "First name must be less than 50 characters")
      .required("First name is required"),

  signupLastName: Yup.string()
      .min(2, "Last name must be at least 2 characters")
      .max(50, "Last name must be less than 50 characters")
      .required("Last name is required"),

  signupEmail: Yup.string()
      .email("Please enter a valid email address")
      .required("Email address is required"),

  phoneNumber: Yup.string()
      .matches(/^\d+$/, "Phone number must contain only digits")
      .min(10, "Phone number must be at least 10 digits")
      .max(15, "Phone number must be less than 15 digits")
      .required("Phone number is required"),

  signupPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(
          passwordRules,
          "Password must contain at least one uppercase letter, one lowercase letter, and one number"
      )
      .required("Password is required"),

  signupConfirmPassword: Yup.string()
      .oneOf([Yup.ref("signupPassword"), null], "Passwords must match")
      .required("Please confirm your password"),
});

// You can also create other schemas for different forms
export const loginSchema = Yup.object().shape({
  email_address: Yup.string()
      .email("Please enter a valid email address")
      .required("Email address is required"),

  password: Yup.string()
      .required("Password is required"),
});

// For password reset
export const resetPasswordSchema = Yup.object().shape({
  email_address: Yup.string()
      .email("Please enter a valid email address")
      .required("Email address is required"),
});

// For password change
export const changePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
      .required("Current password is required"),

  newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(
          passwordRules,
          "Password must contain at least one uppercase letter, one lowercase letter, and one number"
      )
      .notOneOf([Yup.ref("currentPassword")], "New password must be different from current password")
      .required("New password is required"),

  confirmNewPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Please confirm your new password"),
});

export const advancedSchema = yup.object().shape({
  first_name: yup
    .string()
    .min(3, "Username must be at least 3 characters long")
    .required("Required"),
  email_address: yup
    .string()
    .email("Please enter a valid email")
    .required("Required"),
  last_name: yup
    .string()
    .min(3, "Username must be at least 3 characters long")
    .required("Required"),
  phone_number: yup.string().phone("KE", true).required("Required"),
});
export const updatePasswordSchema = yup.object().shape({
  old_password: yup.string().required("Required"),
  new_password: yup
    .string()
    .min(5)
    .matches(passwordRules, { message: "Please create a stronger password" })
    .required("Required"),
  confirm_new_password: yup
    .string()
    .oneOf([yup.ref("new_password"), null], "Passwords must match")
    .required("Required"),
});

export const updatePropertySchema = yup.object().shape({
  property_name: yup
    .string()
    .min(3, "Name must be at least 3 characters long")
    .required("Required"),
  location: yup
    .string()
    .min(3, "Location must be at least 3 characters long")
    .required("Required"),
  payment_details: yup
    .string()
    .min(3, "Location must be at least 3 characters long")
    .required("Required"),
  water_bill: yup.number().required("Required"),
  electricity_bill: yup.number().required("Required"),
  minimum_water_bill: yup.number().required("Required"),
  minimum_electricity_bill: yup.number().required("Required"),
  other_charges: yup.number().required("Required"),
  query_number: yup.string().required("Required"),
  minimum_days_to_vacate: yup.number().required("Required"),
});

export const updatePropertyPaymentDetailsSchema = yup.object().shape({
  ho_number: yup
      .string()
      .min(5, "Must be at least 5 characters long")
      .required("Required"),
  till_number: yup
      .string()
      .min(5, "Must be at least 5 characters long")
      .required("Required"),
  short_code: yup
      .string()
      .min(3, "Must be at least 5 characters long")
      .required("Required"),
  pass_key: yup.string().required("Required"),
  consumer_secret: yup.string().required("Required"),
});

/*  jobType: yup
    .string()
    .oneOf(["designer", "developer", "manager", "other"], "Invalid Job Type")
    .required("Required"),
  acceptedTos: yup
    .boolean()
    .oneOf([true], "Please accept the terms of service"),*/
